
import { useState, useEffect, useCallback } from 'react';
import { districtService } from '../Services/districtService';
import { useDispatch } from 'react-redux';
import { handleApiError } from '../Utils/ApiErrorHandler';
import { setSuccessSnack } from '../Reducers/snackSuccess';

const useGetDistricts = (role) => {
    const dispatch = useDispatch();

    const [districts, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    // Separate loading states
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const fetchDistricts = useCallback(async() => {
        setLoading(true); 
        try {
            const data = await districtService.getDistricts();
            setList(data);
            return data;
        } catch (error) {
            return handleApiError(error, dispatch, "get districts")
        } finally {
            setLoading(false);
        }
    }, [role]);

    const deleteDistrict = async (id) => {
        if (!id) return false;
        try {
          setDeleting(true);
          const data = await districtService.deleteDistrict(id);
          
          if (data.status === 'Removed') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: 'Removed admin district'
            }));
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'delete district');
          return false;
        } finally {
          setDeleting(false);
        }
      };

      const createDistrict = async (values) => {
        try {
          setCreating(true);
          const data = await districtService.createDistrict(values);
          
          if (data.status === 'OK') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: `Created district successfully with id ${data.id}`
            }));
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'create district');
          return false;
        } finally {
          setCreating(false);
        }
      };
      
      const updateDistrict = async (values) => {
        try {
          setUpdating(true);
          const data = await districtService.updateDistrict(values);
          
          if (data.status === 'Updated') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: 'Updated district'
            }));
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'update district');
          return false;
        } finally {
          setUpdating(false);
        }
      };

    return { districts, loading, deleting, creating, updating, fetchDistricts, deleteDistrict, createDistrict, updateDistrict };
}

export default useGetDistricts;